/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse
     */
    url?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

